import { render, staticRenderFns } from "./LandingRegion.vue?vue&type=template&id=f0b22e54&scoped=true"
import script from "./LandingRegion.vue?vue&type=script&lang=js"
export * from "./LandingRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b22e54",
  null
  
)

export default component.exports